import PropTypes from "prop-types"
import { UUID, DATE } from "helpers/shapes"

export const TEAM_TOKEN = PropTypes.shape({
  id: UUID.isRequired,
  name: PropTypes.string.isRequired,
  teamRole: PropTypes.string.isRequired,
  createdAt: DATE.isRequired,
  updatedAt: DATE.isRequired,
})
